module.exports = __webpack_public_path__ + "static/media/logo_horizontal_white.3a60ee13.svg";